export const setLocalStorage = {
  state: "languageOption",
  lang: { english: "English", german: "german" },
};
